import { apiClient } from '../../utils';
import { handleError } from '../';

export const removeSlider = async ({ siteId, sliderId }) => {
  try {
    const { result } = await apiClient.post('/merchant/slider/remove', {
      data: { site: siteId, slider: sliderId },
    });
    return result;
  } catch (e) {
    handleError(e);
    throw e;
  }
};
